import { Analysis, PossibleRootCauseCategory } from '.';

export class GlucoseAnalysis extends Analysis {
    calculateInsights() {
        if (this.ba.glucose.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_6000);
        } else if (this.ba.glucose.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_6010);
        }

        if (this.ba.hemoglobinA1c.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_6020);
        } else if (this.ba.hemoglobinA1c.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_6030);
        }

        if (this.ba.insulin.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_6040);
        } else if (this.ba.insulin.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_6050);
        }

        if (this.ba.cpeptide.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_6060);
        } else if (this.ba.cpeptide.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_6070);
        }

        if (this.ba.triglycerides.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_6075);
        }
      
        if (this.ba.amylase.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_6080);
        } else if (this.ba.amylase.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_6090);
        }
    }
}